import { ROUTES } from "@kappa-v2/contracts";
export class KappaApiClient {
    endpointApi;
    authToken;
    tenantId;
    constructor(endpointApi, authToken, tenantId) {
        this.endpointApi = endpointApi;
        this.authToken = authToken;
        this.tenantId = tenantId;
    }
    async get(path) {
        const response = await fetch(`${this.endpointApi}${path}`, {
            headers: this.buildHeaders()
        });
        if (!response.ok) {
            throw new Error(`HTTP ${response.status} on GET ${path}`);
        }
        return (await response.json());
    }
    buildHeaders() {
        const headers = {
            "content-type": "application/json"
        };
        if (this.authToken) {
            headers.authorization = `Bearer ${this.authToken}`;
        }
        if (this.tenantId) {
            headers["x-tenant-id"] = this.tenantId;
        }
        return headers;
    }
}
export async function loadAppConfiguration(discoveryUrl) {
    const response = await fetch(discoveryUrl);
    if (!response.ok) {
        throw new Error(`Unable to load discovery from ${discoveryUrl}`);
    }
    return (await response.json());
}
export const compatibilityRoutes = ROUTES;
//# sourceMappingURL=index.js.map